export const testimonials = [
  {
    name: 'Carlos Eduardo Silva',
    location: 'São Paulo, SP',
    text: 'Fiquei impressionado com a rapidez! Meu carro quebrou na rodovia e em menos de 10 minutos o guincho chegou. Profissionais muito atenciosos e equipamento de primeira qualidade. Super recomendo!',
    image: 'https://public.readdy.ai/ai/img_res/d3c05b8ff1f06b5cdd3ff5a5f433b868.jpg'
  },
  {
    name: 'Marina Oliveira',
    location: 'Rio de Janeiro, RJ',
    text: 'Precisei de guincho de madrugada e fui atendida prontamente. O motorista foi super educado e cuidadoso com meu carro. Preço justo e serviço impecável. Salvaram minha noite!',
    image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20in%20her%2030s%20smiling%20warmly%2C%20elegant%20business%20attire%2C%20confident%20friendly%20expression%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%20professional%20headshot&width=100&height=100&seq=testimonial-marina&orientation=squarish'
  },
  {
    name: 'Roberto Mendes',
    location: 'Belo Horizonte, MG',
    text: 'Excelente serviço! Já usei outras vezes e sempre sou bem atendido. A equipe é profissional, o guincho é moderno e o atendimento é rápido. Tenho o número salvo no celular para qualquer emergência.',
    image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20in%20his%2050s%20smiling%20kindly%2C%20casual%20smart%20attire%2C%20trustworthy%20friendly%20expression%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%20professional%20headshot&width=100&height=100&seq=testimonial-roberto&orientation=squarish'
  }
];